import { useQuery } from '@tanstack/react-query';
import { ownedParkingOptions } from '../../constants/ownedParkings';
export function useOwnedParkings(filter, scope) {
    const { data, isLoading, isSuccess } = useQuery(ownedParkingOptions.get(filter, scope));
    return {
        ownedParkings: data ?? [],
        loadingOwnedParkings: isLoading,
        isSuccess,
    };
}
